import {IEventProductData} from 'coreClasses/events/IEvents';
import ECommerceProductModel from './EcommerceProductModel';

/**
 * Represents ECommerceProductHitModel
 */
export default class ECommerceProductHitModel extends ECommerceProductModel {
	public list: string;

	/**
	 * @constructor
	 * @param {IEventProductData} productData - product data
	 * @param {string} source - source
	 */
	constructor(productData: IEventProductData, source: string) {
		super(productData);

		this.list = source;

		if (productData.product?.isReady() && 'attributes' in productData) {
			for (let attribute in productData.attributes) {
				this[attribute] = productData.attributes[attribute];
			}
		}
	}
};
